module.exports = __webpack_public_path__ + "static/media/user-icon.6c633236.svg";